interface RouteConfig {
  path: string;
  title: string;
  subtitle?: string;
}

interface RoutesConfig {
  DASHBOARD: RouteConfig;
  MEDIA: RouteConfig;
  AFFILIATE_LINKS: RouteConfig;
  AFFILIATE_LINKS_SELECT_PRODUCTS: RouteConfig;
  AFFILIATE_LINKS_CREATE_LINK: RouteConfig;
  AFFILIATE_LINKS_CREATE_LANDING: RouteConfig;
  AFFILIATE_LINKS_CREATE_WIDGET: RouteConfig;
  AFFILIATE_LINKS_SELECT_BANNER: RouteConfig;
  ADVERTISERS: RouteConfig;
  ADVERTISER_DETAIL: RouteConfig;
  INCOME: RouteConfig;
  INCOME_GENERAL: RouteConfig;
  INCOME_DETAIL: RouteConfig;
  INCOME_INVOICES: RouteConfig;
  INVOICE_DETAIL: RouteConfig;
  PERFORMANCE: RouteConfig;
  PERFORMANCE_LINKS: RouteConfig;
  PERFORMANCE_OVERVIEW: RouteConfig;
  PERFORMANCE_PRODUCTS: RouteConfig;
  TICKETS: RouteConfig;
  PROFILE: RouteConfig;
  NOT_FOUND: RouteConfig;
}

export const ROUTES: RoutesConfig = {
  DASHBOARD: {
    path: '/',
    title: 'پیشخوان',
  },
  MEDIA: {
    path: '/media',
    title: 'رسانه‌های من',
  },
  AFFILIATE_LINKS: {
    path: '/affiliate-links',
    title: 'لینک‌ افیلیت',
  },
  AFFILIATE_LINKS_SELECT_PRODUCTS: {
    path: '/affiliate-links/select-products',
    title: 'انتخاب محصولات',
  },
  AFFILIATE_LINKS_CREATE_LINK: {
    path: '/affiliate-links/create-link',
    title: 'ساخت لینک',
  },
  AFFILIATE_LINKS_CREATE_LANDING: {
    path: '/affiliate-links/create-landing',
    title: 'ساخت لندینگ',
  },
  AFFILIATE_LINKS_CREATE_WIDGET: {
    path: '/affiliate-links/create-widget',
    title: 'ساخت ویجت',
  },
  AFFILIATE_LINKS_SELECT_BANNER: {
    path: '/affiliate-links/select-banner',
    title: 'انتخاب بنر',
  },
  ADVERTISERS: {
    path: '/advertisers',
    title: 'تبلیغ‌دهندگان',
  },
  ADVERTISER_DETAIL: {
    path: '/advertisers/:id',
    title: 'جزئیات تبلیغ‌دهنده',
  },
  PERFORMANCE: {
    path: '/performance',
    title: 'عملکرد لینک‌ها',
  },
  PERFORMANCE_LINKS: {
    path: '/performance/links',
    title: 'عملکرد لینک‌ها',
  },
  PERFORMANCE_OVERVIEW: {
    path: '/performance/overview',
    title: 'نگاه کلی',
  },
  PERFORMANCE_PRODUCTS: {
    path: '/performance/products',
    title: 'عملکرد محصولات',
  },
  INCOME: {
    path: '/income',
    title: 'درآمد من',
  },
  INCOME_GENERAL: {
    path: '/income/general',
    title: 'درآمد من',
  },
  INCOME_DETAIL: {
    path: '/income/detail',
    title: 'درآمد من',
  },
  INCOME_INVOICES: {
    path: '/income/invoices',
    title: 'درآمد من',
  },
  INVOICE_DETAIL: {
    path: '/invoice/:id',
    title: 'جزئیات فاکتور',
  },
  TICKETS: {
    path: '/tickets',
    title: 'راهنمایی و پشتیبانی',
  },
  PROFILE: {
    path: '/profile',
    title: 'حساب کاربری',
  },
  NOT_FOUND: {
    path: '*',
    title: '',
  },
} as const;
